import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
const LanguageSwitcher = () => {
    const { t, i18n } = useTranslation();
    const langs = useMemo(() => [
        { label: t("setup.lang.en"), code: "en", flag: "🇬🇧" },
        { label: t("setup.lang.cz"), code: "cz", flag: "🇨🇿" },
        { label: t("setup.lang.ro-MD"), code: "ro-MD", flag: "🇲🇩" }
    ], [t]);
    const changeLanguage = useCallback(async (lang) => {
        localStorage.setItem("lang", lang);
        await i18n.changeLanguage(lang);
    }, [i18n]);
    return (_jsx("div", { children: _jsx("div", { className: "btn-group", role: "group", "aria-label": "Language selection", children: langs.map(({ code, label, flag }) => (_jsxs(React.Fragment, { children: [_jsx("input", { type: "radio", className: "btn-check", name: "language", id: code, autoComplete: "off", onChange: () => changeLanguage(code), checked: i18n.language === code }), _jsxs("label", { className: "btn btn-outline-primary", htmlFor: code, children: [flag, " ", label] })] }, code))) }) }));
};
export default LanguageSwitcher;
